import { useModelService } from "@shared/services/api/hooks/useModelService";
import PublicBasedProductsRepository from "../repositories/PublicBasedProductsRepository";

const usePublicProductsService = () => {
  const repository = new PublicBasedProductsRepository();

  const modelService = useModelService(repository);

  return {
    ...modelService,
  };
};

export default usePublicProductsService;
